import { FieldworkerAssignmentList } from "./FieldworkerAssignmentList";
import { FieldworkerAssignmentsHorizontal } from "./FieldworkerAssignmentsHorizontal";
import { FieldworkerAssignmentsFragment } from "./fragments.generated";

type FieldworkerAssignmentsProps = {
    fieldworkersRequired: number;
    fieldworkers: FieldworkerAssignmentsFragment[];
    variant?: "horizontal" | "list";
    size?: "default" | "small";
};

export function FieldworkerAssignments({
    fieldworkersRequired,
    fieldworkers,
    variant = "horizontal",
    size = "default",
}: FieldworkerAssignmentsProps) {
    const fieldworkersStillNeeded = fieldworkersRequired - fieldworkers.length;

    return variant === "horizontal" ? (
        <FieldworkerAssignmentsHorizontal
            fieldworkers={fieldworkers}
            fieldworkersStillNeeded={fieldworkersStillNeeded}
            fieldworkersRequired={fieldworkersRequired}
            size={size}
        />
    ) : (
        <FieldworkerAssignmentList
            fieldworkers={fieldworkers}
            fieldworkersStillNeeded={fieldworkersStillNeeded}
            fieldworkersRequired={fieldworkersRequired}
        />
    );
}
